module.exports = __webpack_public_path__ + "images/emoji/camera.7aef0e33de29c10fd268.png";